

































































import _ from 'lodash';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { State, Action, namespace } from 'vuex-class';
import { ActionError as campaignStoreErr, CurrentCampaignType } from '@/store/campaign/types';

import { Report as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { SetAdset as feedbackTerms } from '@/const/terms/feedback/adset';
import { ReportConfirm } from '@/const/terms/feedback/confirm';
import { SetCampaign as campaignFeedback } from '@/const/terms/feedback/campaign';
import { SetAdset as adsetFeedback } from '@/const/terms/feedback/adset';

import { DATE_TYPE, ID_TYPE } from '@/const/types';
import { ADJUSTMENT_TYPE } from '@/const/types/adjustment';
import { ADJUSTMENT_MAP } from '@/const/options';
import { STATUS } from '@/const/status/index';
import { TableOptionType, DefaultOption } from '@/const/options/DefaultTableOption';
import { IPrice } from '@/pages/campaign/adset/editingTypes';
import { CampaignDataType, ICampaignData } from '@/pages/campaign/types';
import { IAdsetSummary } from '@/pages/campaign/adset/types';
import { 
    SearchFormType,
    AdsetSummaryType,
    AdsetSummaryResponse,
    IAdsetReportWrap,
    AdsetReportResponse,
    IAdsetReport,
    RowType,
    TerminalRowType,
    SummaryRowType,
    SingleTerminalWrapperRowType,
    AdsetReportResponseWrap,
} from './detailTypes';
import { IAdsetBrief, AdsetResponse, IAdsetSummary as IAdsetSummaryOrigin} from '@/pages/campaign/adset/types';
import { CampaignInfoResponse } from '@/pages/campaign/editingTypes';

import { RawLocation } from 'vue-router';
import { SummaryMethodParams } from 'element-ui/types/table';
import { Grid } from '@toast-ui/vue-grid';

import { ORIGIN_FORMAT } from '@/utils';
import { AxiosError, AxiosResponse } from 'axios';

import DateRangePicker from '@/components/ElementComponent/Date/DateRangePicker.vue';
import Select from '@/components/ElementComponent/Select/index.vue';
import { SelectOptionType } from '@/components/ElementComponent/Select/types';
import GridAdsetDetail from '@/components/pages/report/campaign/adset/GridAdsetDetail.vue';

const campaignModule = namespace('Campaign');

@Component<ReportAdsetDetail>({
    name: 'ReportAdsetDetail',
    components: {
        DateRangePicker,
        Select,
        GridAdsetDetail,
    },
})
export default class ReportAdsetDetail extends Vue {
    private terms = terms;
    private compTerms = compTerms;
    private confirmTerms = ReportConfirm;

    private tableOptions: TableOptionType = DefaultOption;
    private loading: boolean = false;
    private subLoading: number = 0;
    private isUtilsCollapsed: boolean = false;
    private allExpandToggleConfirmVisible: boolean = false;
    private isAllExpanded: number = 0;

    private filterForm: SearchFormType = { status: STATUS.ALL, query: ''};
    private statusOptions: { value: STATUS; label: string; }[] = [
        { value: STATUS.ALL, label: '모든 상태' },
        { value: STATUS.ACTIVE, label: '활성' },
        { value: STATUS.INACTIVE, label: '비활성' },
    ];
    private appOptions: SelectOptionType[] = [];
    private dateValue: DATE_TYPE[] = [((()=> {
        let t = new Date(); t.setDate(t.getDate() - 6);
        return t;
    })()) as DATE_TYPE, new Date()];
    
    private tableData: AdsetSummaryType = [];
    private checkedAdset: AdsetSummaryType = [];

    

    @campaignModule.State('currentCampaign') private currentCampaign!: CurrentCampaignType;
    @campaignModule.Action('SET_CURRENT_CAMPAIGN') private setCurrentCampaign: any;
    @campaignModule.Action('SET_CURRENT_ADSET') private setCurrentAdset: any;

    get date() {
        return [
            moment(this.dateValue[0]).format('YYYYMMDDHH'),
            moment(this.dateValue[1]).format('YYYYMMDDHH'),
        ];
    }
    
    get expandButtonContent() {
        const num = this.isAllExpanded;
        return (
            ((num === 0 || num === -1)? '모든 광고세트' : (num === 2 ? '모두' : '모든 인벤토리'))
            +
            (num === 2? ' 접기' : ' 펼치기')
        );
    }
    private toggleAllHandler() {
        this.allExpandToggleConfirmVisible = false;
        if (this.loading || this.subLoading > 0) {
            return;
        }
        const gridWrapper = this.$refs.gridWrapper as GridAdsetDetail;
        const table = gridWrapper.$refs.table as Grid;
        const rows = table.invoke('getRows') as RowType[];
        this.loading = true;
        setTimeout(() => {
            if (this.isAllExpanded === 2) {
                // rows.reverse().forEach((item: any) => {
                //     const row = item as TerminalRowType;
                //     if (row._children !== false) {
                //         table.invoke('collapse', row.rowKey, true);
                //     }
                // })
                this.isAllExpanded = -1;
                table.invoke('collapseAll');
            } else {
                // rows.forEach((item: any) => {
                //     const row = item as SummaryRowType;
                //     if (this.isAllExpanded === 0 || this.isAllExpanded === -1 && row._children === true) {                    
                //         table.invoke('expand', row.rowKey, true);
                //     } else if (this.isAllExpanded === 1 && typeof row._children !== 'boolean') {
                //         table.invoke('expand', row.rowKey, true);
                //     }
                // })
                table.invoke('expandAll');
                if (this.isAllExpanded === -1) {
                    this.isAllExpanded = 2;
                } else {
                    this.isAllExpanded++;
                }
            }
            this.loading = false;
        })
    }
    private expandedHandler({ rowKey, descendantRowKeys, instance }: tuiGrid.IColumnEventOptions & { descendantRowKeys: number[] | string[] | undefined[] }) {
        const gridWrapper = this.$refs.gridWrapper as GridAdsetDetail;
        const table = gridWrapper.$refs.table as Grid;
        const row = table.invoke('getRow', rowKey) as SummaryRowType;
        if (row.date) {
            return;
        }
        if (descendantRowKeys.length === 0) {
            this.subLoading++;
            this.getAdsetReportDaily(row as IAdsetSummary).then((res: any) => res.data)
                .then((data: AdsetReportResponse) => {
                    const reportBuffer: IAdsetReportWrap[] = [];
                    const reportMap: AdsetReportResponseWrap = _.groupBy(data, "id");
                    Object.entries(reportMap).forEach(([key, value]: [ID_TYPE, IAdsetReport[]] ) => {
                        const tmp: IAdsetReportWrap = <IAdsetReportWrap>{ id: key, status: STATUS.INACTIVE, impression: 0, click: 0, dailyBudget: 0, spentBudget: 0, beginDate: this.dateValue[0], endDate: this.dateValue[1]};
                        value.forEach((item: IAdsetReport) => {
                            item._extraData = {
                                className: {
                                    row: ['tuiGridTreeTerminal'],
                                },
                            };
                            tmp.name = item.name;
                            tmp.price = item.price;
                            tmp.impression += item.impression;
                            tmp.click += item.click;
                            tmp.dailyBudget += item.dailyBudget;
                            tmp.spentBudget += item.spentBudget;
                            tmp.status |= item.status;
                            
                            item.ctr = item.impression === 0 ? -1 : (item.click / item.impression) * 100;
                            item._children = false;
                        });
                        tmp.ctr = tmp.impression === 0 ? -1 : (tmp.click / tmp.impression) * 100;
                        tmp._children = value.sort((a: IAdsetReport,b: IAdsetReport) => a.reportDate < b.reportDate ? 1 : -1);
                        tmp._extraData = {
                            className: {
                                row: ['tuiGridTreeTerminalWrapper'],
                            },
                        }
                        reportBuffer.push(tmp);
                    })
                    setTimeout(() => {
                        table.invoke('appendRow', reportBuffer.sort((a: IAdsetReportWrap,b: IAdsetReportWrap) => a.name < b.name ? -1 : 1) as SingleTerminalWrapperRowType[], { parentRowKey: rowKey});
                        this.subLoading--;
                    })
                })
                .catch((err: AxiosError) => {
                    if (err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(feedbackTerms.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                    }
                    throw err;
                })
        }
    }

    private excelDownloadHandler() {
        this.subLoading++;
        const gridWrapper = this.$refs.gridWrapper as GridAdsetDetail;
        const table = gridWrapper.$refs.table as Grid;
        const columns = table.invoke('getColumns') as tuiGrid.IColumnInfoOptions[];
        const json = JSON.stringify(table.invoke('getRows') as RowType[]);
        const refinedJson = json
                .replace(/<span.[\S\s].[a-zA-Z=/"\\]*>.[<>a-zA-Z0-9 =\\\/"-]*.<[/]span>/g, '')
                .replace(/<span.[\S\s].[a-zA-Z=/"\\]*>/g, '')
                .replace(/<i.[\s\S].[a-z]*=.[a-z\"\\-]*><\/i>/g, '')
                .replace(/<\/span>/g, '');
        const rows = JSON.parse(refinedJson) as RowType[];
        let content = "";
        let cnt = 0;
        const keys: string[] = columns.map((item: tuiGrid.IColumnInfoOptions) => item.name);
        columns.forEach((item: tuiGrid.IColumnInfoOptions, index: number) => {
            if (index !== 0) content += ',';
            content += '"' + item.title + '"';
        });
        rows.forEach((item: RowType) => {
            content += '\n';
            const isParagraph = 
                (item['_treeData' as keyof RowType] as any)['childrenRowKeys'] &&
                !(item['_treeData' as keyof RowType] as any).hasOwnProperty('parentRowKey')

            if (isParagraph) {
                content += '\n';
            }
            keys.forEach((key: string, index: number) => {
                if (index !== 0) content += ',';
                content += '"';
                const checkNum = Number.parseFloat(item[key as keyof RowType] as string);
                if (key.toLowerCase().includes('date')) {
                    if (item[key as keyof RowType] === null || item[key as keyof RowType] === undefined)
                        content += '-';
                    else
                        content += moment((item[key as keyof RowType] as Date)).format('YYYY.MM.DD')
                } else if (key.toLowerCase() === 'price') {
                    const price = item[key as keyof RowType] as IPrice;
                    if (price) {
                        content += ADJUSTMENT_MAP[price.type] + " | " + ORIGIN_FORMAT.NumberFormatOrigin(price.value);
                    }
                } else if (key.toLowerCase() === 'status') {
                    if (Number.isNaN(checkNum)) {
                        content += item[key as keyof RowType];
                    } else {
                        content += (((checkNum & STATUS.ACTIVE) === STATUS.ACTIVE) ? '활성화 | ' : '비활성화 | ') + item[key as keyof RowType];
                    }
                } else if (key.toLowerCase() !== 'name' && !Number.isNaN(checkNum)) {
                    if (key.toLowerCase() === 'ctr' && checkNum === -1) {
                        content += ' - ';
                    } else {
                        content += ORIGIN_FORMAT.NumberFormatOrigin(checkNum);
                    }
                } else if (item[key as keyof RowType]){
                    content += item[key as keyof RowType];
                }
                content += '"';
            })
            if (isParagraph) {
                cnt++;
                content += ",,** "+cnt+ `${item.name ? '. '+item.name : ''}`+" **";
            }
        })
        const BOM = "\uFEFF";
        content = BOM + content
        const url = window.URL.createObjectURL(new Blob([content], {type: "text/csv"}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `[${terms.adsetDetail.title}][${this.currentCampaign.name}]_${moment(this.dateValue[0]).format('YYYY-MM-DD')}_${moment(this.dateValue[1]).format('YYYY-MM-DD')}.csv`)
        link.click();
        this.subLoading--;
        return;
    }

    private resizeHandler() {
        this.$nextTick(() => {
            const gridWrapper = this.$refs.gridWrapper as GridAdsetDetail;
            const table = gridWrapper.$refs.table as Grid;
            table.invoke('refreshLayout');
        });
    }

    
    private refreshDate(v: Date[]) {
        if (v) {
            this.getAdsetResponseHandler();
        }
    }
    private async setCurrentAdsetHandler(scope: any, to: RawLocation) {
        try {
            await this.setCurrentAdset({
                id: scope.row.id,
                name: scope.row.name,
            });
            const routerData = this.$router.resolve(to);
            window.open(routerData.href, '_blank');
        } catch (err) {
            switch (err.type) {
                case campaignStoreErr.SET_CURRENT_ADSET:
                    this.$notify.error(feedbackTerms.currentAdset.error.fail);
                    break;
            }
            throw err;
        }
    }

    private getAdsetResponseHandler() {
        this.loading = true;
        this.checkedAdset = [];
        this.getAdsetResponseSummary().then((res: any) => res.data)
            .then((data: AdsetSummaryResponse) => {
                this.tableData = data.adsets.sort((a: IAdsetSummary, b: IAdsetSummary) => a.name < b.name ? -1 : 1)
                    .map((item: IAdsetSummary) => {
                        const imp = item.impression;
                        const click = item.click;
                        const ctr = imp === 0 ? -1 : (click/imp) * 100;
                        const idList = [] as ID_TYPE[];
                        item.targets.forEach((t: IAdsetBrief) => {
                            (item.status as STATUS) |= t.status;
                            idList.push(t.adset_id);
                        })
                        return {
                            ...item,
                            idList: idList,
                            ctr: ctr,
                            _children: true,
                        } as IAdsetSummary;
                    });
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{
                this.loading = false;
                this.isAllExpanded = 0;
            })
    }
    private getAdsetResponseSummary(){
        return this.$http.adserverAPI.post('GetAdsetReport', {
            campaign_id: this.currentCampaign.id,
            placements: ['1', '2', '3', '4', '5', '6'],
            since: this.date[0],
            until: this.date[1],
            status: this.filterForm.status,
            query: this.filterForm.query,
            page_no: 0,
        })
    }

    private getAdsetReportDaily(row: IAdsetSummary): Promise<any> {
        return  this.$http.adserverAPI.post('GetAdsetDetailReport', {
            campaign_id: this.currentCampaign.id,
            adset_ids: row.idList,
            since: this.date[0],
            until: this.date[1],
        }, { withUniqueCanceler: true });
    }

    private async created() {
        if (this.$route.params.campaignID !== this.currentCampaign.id) {
            const campaignID = this.$route.params.campaignID;
            await this.$http.adserverAPI.post('GetCampaignInfo', {campaign_id: campaignID}).then((res: any) => res.data)
                .then(async (data: CampaignInfoResponse) => {
                    if (data && (data as any).result === null) {
                        throw new Error(campaignFeedback.getResponse.error.notFound);
                    }
                    try {
                        await this.setCurrentCampaign({
                            id: data.id,
                            name: data.name,
                            app: data.app,
                        });
                    } catch (err) {
                        switch (err.type) {
                            case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                                throw new Error(campaignFeedback.getResponse.error.setCurrentCampaign);
                                break;
                        }
                        throw new Error(campaignFeedback.getResponse.error.fail);
                    }
                })
                .catch((err: AxiosError) => {
                    if(err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(campaignFeedback.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                        this.$router.push({name: 'reportCampaign'});
                    }
                    throw err;
                })
        }
        this.getAdsetResponseHandler();
    }
}
